import { render } from "./MedicalRecord.vue?vue&type=template&id=bc265abc&scoped=true"
import script from "./MedicalRecord.vue?vue&type=script&lang=js"
export * from "./MedicalRecord.vue?vue&type=script&lang=js"

import "./MedicalRecord.vue?vue&type=style&index=0&id=bc265abc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc265abc"]])

export default __exports__